import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ImportPersonsFromAnotherGroupUseCaseInterface } from 'domain/usecases';

export class RemoteImportPersonsFromAnotherGroup
  implements ImportPersonsFromAnotherGroupUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<ImportPersonsFromAnotherGroupUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ImportPersonsFromAnotherGroupUseCaseInterface.Params,
  ): Promise<ImportPersonsFromAnotherGroupUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'post',
      url: this.url,
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
